<div class="content">
  <div class="configurationBannerHeader" (click)="toggleExpansion()">
    <label class="configurationBannerLabel">Mechanical Options</label>
    <span class="spacer"></span>
    <mat-icon class="expansionIcon">{{ getExpansionIcon() }}</mat-icon>
  </div>
  @if (isExpanded) {
    <div class="detail">
      <div class="configurationDetailRow">
        @if (returnAirSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Return Air:</label>
            <select
              class="halfWidthInputField"
              #returnAirInput
              [class.invalidConfigurationSelection]="isInvalidSelection(returnAirSelection.Name)"
              (change)="selectionChanged(returnAirSelection, returnAirInput.value)"
              [value]="returnAirSelection.Value.toString()">
              @for (allowable of returnAirSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid"
                  class="configurationSelectionOption"
                  [selected]="returnAirSelection.Value && returnAirSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">
                  {{ allowable.Description }}
                </option>
              }
            </select>
          </span>
        }
      </div>
      <div class="configurationDetailRow">
        @if (outsideAirSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Outside Air:</label>
            <select
              class="halfWidthInputField"
              #outsideAirInput
              [class.invalidConfigurationSelection]="isInvalidSelection(outsideAirSelection.Name)"
              (change)="selectionChanged(outsideAirSelection, outsideAirInput.value)"
              [value]="outsideAirSelection.Value.toString()">
              @for (allowable of outsideAirSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid"
                  class="configurationSelectionOption"
                  [selected]="outsideAirSelection.Value && outsideAirSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">
                  {{ allowable.Description }}
                </option>
              }
            </select>
          </span>
        }
      </div>
      <div class="configurationDetailRow">
        @if (outsideAirLocationSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Outside Air Location:</label>
            <select
              class="halfWidthInputField"
              #outsideAirLocationInput
              [class.invalidConfigurationSelection]="isInvalidSelection(outsideAirLocationSelection.Name)"
              (change)="selectionChanged(outsideAirLocationSelection, outsideAirLocationInput.value)"
              [value]="outsideAirLocationSelection.Value.toString()">
              @for (allowable of outsideAirLocationSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid"
                  class="configurationSelectionOption"
                  [selected]="outsideAirLocationSelection.Value && outsideAirLocationSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">
                  {{ allowable.Description }}
                </option>
              }
            </select>
          </span>
        }
      </div>
    </div>
  }
</div>
